// start パラメータの定義
export const START_PARAMS = {
  INIT: 'init', // はじめから
  CONFIRM: 'confirm', // 確認モーダルを開く
  CONTINUE: 'continue', // つづきから
} as const

export type StartParamType = (typeof START_PARAMS)[keyof typeof START_PARAMS]

/**
 * プレビュー（おためしプレイ）opt-in 用の URL クエリのキーと値。
 * 表示判定（usePreviewVisible）と projectId 遷移時の引き継ぎ
 * （projectQuery）の両方から参照するためここで一元管理する。
 */
export const PREVIEW_PARAM = 'preview'
export const PREVIEW_ON_VALUE = 'on'

/**
 * ビデオモーダルの表示制御パラメータ。
 * `?video=0` のとき非表示（Aeon Fantasy からの遷移）、省略時・それ以外の値はすべて表示。
 */
export const VIDEO_PARAM = 'video'
export const VIDEO_HIDDEN_VALUE = '0'

/**
 * M1 パーツ連動解除パラメータ。
 * `?parts=0` のとき全パーツ表示（応用チャプター選択時と同じ挙動）、省略時はチャプター連動あり。
 */
export const PARTS_PARAM = 'parts'
export const PARTS_HIDDEN_VALUE = '0'

/** Aeon Fantasy M1 トライアルミッションのスラッグ（`rj1_trial`）。 */
export const AEON_SLUG = 'rj1_trial'
